import React from "react";
import { TabButtonStyled, TabsContainer } from "./styles";

interface TabsSelectorProps {
  tabs: string[];
  activeTab: string;
  onTabChange: (tab: string) => void;
}

export const Tabs = ({ tabs, activeTab, onTabChange }: TabsSelectorProps) => {
  return (
    <TabsContainer>
      {tabs.map((type) => (
        <TabButtonStyled
          key={type}
          $active={activeTab === type}
          onClick={() => onTabChange(type)}
        >
          {type.charAt(0).toUpperCase() + type.slice(1)}
        </TabButtonStyled>
      ))}
    </TabsContainer>
  );
};
